import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

type Tone = 'jungle' | 'trinidad' | 'gold' | 'neutral';

@Component({
  selector: 'cnt-stat-tile',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './stat-tile.component.html',
})
export class StatTileComponent {
  @Input() label = '';
  @Input() value: string | number = '';
  @Input() icon = 'insights';
  @Input() trend?: string;
  @Input() tone: Tone = 'jungle';
  @Input() spark?: number[];

  /** Unique id for SVG gradient defs, so multiple tiles don't collide. */
  readonly uid = Math.random().toString(36).slice(2, 8);

  /** Sparkline polyline points. Returns '' when no series provided. */
  get sparkPath(): string {
    if (!this.spark || this.spark.length < 2) return '';
    const min = Math.min(...this.spark);
    const max = Math.max(...this.spark);
    const range = max - min || 1;
    const stepX = 80 / (this.spark.length - 1);
    return this.spark
      .map((v, i) => `${(i * stepX).toFixed(2)},${(20 - ((v - min) / range) * 16).toFixed(2)}`)
      .join(' ');
  }

  /** Filled area under the sparkline for a soft tinted glow. */
  get sparkAreaPath(): string {
    if (!this.spark || this.spark.length < 2) return '';
    const points = this.sparkPath.split(' ');
    return `M0,22 L${points.join(' L')} L80,22 Z`;
  }

  get strokeColor(): string {
    switch (this.tone) {
      case 'trinidad': return '#e3530d';
      case 'jungle':   return '#295d42';
      case 'gold':     return '#b3760e';
      default:         return '#222222';
    }
  }
}
